import { AxiosRequestConfig } from 'axios';
import { IOpenCashDrawerRequest } from 'src/cash-office-display/interfaces/OpenCashDrawerRequest';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';

export function postOpenCashDrawer(openCashDrawerRequest: IOpenCashDrawerRequest): Promise<void> {
  const axiosConfig: AxiosRequestConfig = {
    url: '/auth/open-cash-drawer',
    method: 'POST',
    data: openCashDrawerRequest,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: false,
    sessionId: openCashDrawerRequest.sessionId,
  };
  return emeraldRequest<void>(emeraldRequestParams);
}
